export default __webpack_public_path__ + "static/media/carousel-tripgatecbt.3412de24.jpg";